import React from 'react'
import { TextContent } from '../../../../shared/TextContent/TextContent'
import ConsentRequirements from "../StepComponents/ConsentRequirements";
import SupportedDataAccess from '../StepComponents/SupportedDataAccess'

function ProviderAccess() {
    const secureBaseUrl = "https://totalview.healthos.elevancehealth.com"

    const memberInitiatedEndpoints = [
        {
            request: {
                endpointName: "Token",
                action: "Post",
                path: "{base_url}/client.oauth2/registered/api/v1/token",
                description: "Token"
            }
        },
        {
            request: {
                endpointName: "FHIR",
                action: "Get",
                path: "{base_url}/resources/registered/{brand}/api/v1/fhir",
                description: "FHIR"
            }
        },
    ]

    const nonMemberInitiatedEndpoints = [
        {
            request: {
                endpointName: "Token",
                action: "Post",
                path: "{base_url}/client.oauth2/unregistered/api/v1/token",
                description: "Token"
            }
        },
        {
            request: {
                endpointName: "FHIR",
                action: "Get",
                path: "{base_url}resources/unregistered/api/v1/fhir",
                description: "FHIR"
            }
        },
        {
            request: {
                endpointName: "Member Match",
                action: "Get",
                path: "{base_url}resources/unregistered/api/v1/fhir/Patient/$member-match",
                description: "Member Match"
            }
        },
    ]


    return (
        <section className="subgroup" id="provider-access-section">
            <TextContent
                header={"Provider Access"}
                description={"Request FHIR Data through our FHIR API as a Provider"} />
            <div className="step-container">
                <div className="number-and-title">
                    <h2 className="step-number">1</h2>
                    <h2 className="step-title">Registration</h2>
                </div>
                <ul className='step-content'>
                    <li>
                        <p>Reach out to the Interoperability Operations team to onboard as a provider </p>
                    </li>
                    <li>
                        <p>
                            Fill the registration form provided by Elevance Health
                        </p>
                    </li>
                    <li>
                        <p>
                            Receive the credentials to connect to us
                        </p>
                    </li>
                </ul>
            </div>
            <SupportedDataAccess
                accessType={"provider"}
                stepNumber={2}
            />
            <ConsentRequirements stepNumber={3} />
        </section>
    )
}

export default ProviderAccess